import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import arAdmin from "@/i18n/locales/ar/admin.json";
import enAdmin from "@/i18n/locales/en/admin.json";
import {
  type AppLanguage,
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  normalizeLanguage,
  readClientLanguage,
  SUPPORTED_LANGUAGES,
} from "@/i18n/settings";

const isBrowser = typeof window !== "undefined";

const resources = {
  ar: { admin: arAdmin },
  en: { admin: enAdmin },
};

function buildInitOptions(language: AppLanguage) {
  return {
    resources,
    fallbackLng: FALLBACK_LANGUAGE,
    lng: language,
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: "admin",
    ns: ["admin"],
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
    ...(isBrowser
      ? {
          detection: {
            order: ["cookie", "localStorage"],
            lookupCookie: LANGUAGE_STORAGE_KEY,
            lookupLocalStorage: LANGUAGE_STORAGE_KEY,
            caches: ["cookie", "localStorage"],
          },
        }
      : {}),
  };
}

export function initI18n(language?: AppLanguage) {
  const resolvedLanguage =
    language ??
    (isBrowser
      ? (readClientLanguage() ?? DEFAULT_LANGUAGE)
      : DEFAULT_LANGUAGE);

  if (!i18n.isInitialized) {
    if (isBrowser) {
      i18n.use(LanguageDetector);
    }

    i18n.use(initReactI18next).init(buildInitOptions(resolvedLanguage));
    return i18n;
  }

  const current = normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);
  if (current !== resolvedLanguage) {
    void i18n.changeLanguage(resolvedLanguage);
  }

  return i18n;
}

export default i18n;
